import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import MediaPlaceholder from '../components/common/MediaPlaceholder';
import api from '../services/api';

export default function Work() {
  const [caseStudies, setCaseStudies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getPublicCaseStudies()
      .then(res => setCaseStudies(res.case_studies || []))
      .catch(err => console.error('Error loading case studies:', err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-black pt-40 pb-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-4xl mb-32">
          <h1 className="text-6xl md:text-8xl font-serif font-bold mb-10 text-white leading-[1.1]">Strategy & Creativity. Built for Results.</h1>
          <p className="text-2xl text-zinc-400 font-light leading-relaxed">Explore how Maxmark combines market intelligence with exceptional execution to solve business challenges.</p>
        </motion.div>

        {loading ? (
          <p className="text-zinc-500 text-sm">Loading case studies...</p>
        ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20">
          {caseStudies.map((study) => (
            <motion.div key={study.id} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="group">
              <div className="relative aspect-[16/10] overflow-hidden rounded-[2.5rem] mb-10 bg-zinc-900">
                {study.image_url ? (
                  <img src={study.image_url} alt={study.client} className="absolute inset-0 w-full h-full object-cover opacity-60 grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
                ) : (
                  <MediaPlaceholder label={study.client} aspectRatio="aspect-[16/10]" />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
              </div>
              <h3 className="text-[10px] font-bold uppercase tracking-[0.3em] text-blue-500 mb-4">{study.client}</h3>
              <h4 className="text-3xl font-serif font-bold mb-6 text-white">{study.title}</h4>
              <p className="text-zinc-400 mb-8 leading-relaxed font-light">{study.summary}</p>
              <div className="flex flex-wrap gap-2">
                {(study.services && study.services.length > 0 ? study.services : [study.category]).map(s => (
                  <span key={s} className="px-4 py-1.5 rounded-full bg-zinc-900 border border-zinc-800 text-[10px] font-bold uppercase text-zinc-500">{s}</span>
                ))}
              </div>
            </motion.div>
          ))}
          {caseStudies.length === 0 && (
            <p className="text-zinc-500 text-sm col-span-full">Case studies are being prepared. Check back soon.</p>
          )}
        </div>
        )}

        <section className="mt-40 text-center py-32 bg-zinc-950 border border-zinc-900 rounded-[4rem]">
          <h2 className="text-4xl font-serif font-bold mb-10 text-white">We build solutions around challenges, not just assets.</h2>
          <Link to="/contact" className="bg-blue-600 text-white px-12 py-5 rounded-2xl font-bold uppercase tracking-widest text-[10px] inline-block hover:bg-blue-700 transition-colors shadow-lg shadow-blue-600/20">Discuss Your Project</Link>
        </section>
      </div>
    </div>
  );
}
